import { put, takeEvery, call, all } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FETCH_REQUESTTYPE_ACTION,
  FETCH_REQUESTTYPE_SUCCESS_ACTION,
  FETCH_REQUESTTYPE_FAIL_ACTION,
  FETCH_PARTNER_ACTION,
  FETCH_PARTNER_SUCCESS_ACTION,
  FETCH_PARTNER_FAIL_ACTION,
  ADD_OUTBOX_ACTION,
  ADD_OUTBOX_SUCCESS_ACTION,
  ADD_OUTBOX_FAIL_ACTION,
  FETCH_SHIPPERINDIVIDUAL_ACTION,
  FETCH_SHIPPERINDIVIDUAL_FAIL_ACTION,
  FETCH_SHIPPERINDIVIDUAL_SUCCESS_ACTION,
} from "./action";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchrequesttype(action) {
  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(appConfig.ip + "/reqType?isActive=true", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: FETCH_REQUESTTYPE_SUCCESS_ACTION,
        payload: resJSON,
      });

    }
  } catch (err) {
    yield put({
      type: FETCH_REQUESTTYPE_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchpartner(value) {
  let user = JSON.parse(localStorage.getItem("user"));
  let page = (value.value && value.value.page) || 1;
  let url = "";
  let recieverParam = "";
  let search = (value.value && value.value.search) || "";
  if (user.role === "shipper-enterprise" || user.role === "shipper-individual") {
    url = value.value && value.value.filter ? `&role=${value.value.filter}` : `&role=runner,warehouse`;
  }
  else if (user.role === "runner") {
    recieverParam = `&role=shipper-enterprise,shipper-individual`;
    url = value.value && value.value.filter ? `&role=${value.value.filter}` : `&role=shipper-enterprise,shipper-individual,warehouse`;
  } else if (user.role === "warehouse") {
    recieverParam = `&role=shipper-enterprise,shipper-individual`;
    url = value.value && value.value.filter ? `&role=${value.value.filter}` : `&role=shipper-enterprise,shipper-individual,runner`;
  }

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/users?status=created,active&limit=5&ftLogin=false&ser=${search}&page=${page}${url}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: FETCH_PARTNER_SUCCESS_ACTION,
        payload: resJSON,
      });

    }
  } catch (err) {
    yield put({
      type: FETCH_PARTNER_FAIL_ACTION,
      error: err,
    });
  }
}

function* addoutbox(value, partner) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  try {
    yield all(
      value.value.partnerId &&
      value.value.partnerId.map((el) => {
        const outboxValue = {
          message: value.value.message,
          reqType: value.value.reqType,
          orgId: user.orgId,
          userId: user.id,
          partnerId: el.id,
          partnerOrgId: el.orgId,
          keyword: [el.role, user.role]
        };
        return call(rqstOutboxApi, outboxValue);
      })
    );
    yield toast.success("Outbox Added successfully", {
      autoClose: 3000,
      className:"toastClass"
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: ADD_OUTBOX_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* rqstOutboxApi(value) {

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/parterReq`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(value),
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: ADD_OUTBOX_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put(push("/partnerrequests", { tabKey: "outbox_details" }));
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: ADD_OUTBOX_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchshipperindidal(value) {
  let page = (value.value && value.value.page) || 1;
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/users?role=shipper-individual&limit=5&page=${page}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: FETCH_SHIPPERINDIVIDUAL_SUCCESS_ACTION,
        payload: resJSON,
      });

    }
  } catch (err) {
    yield put({
      type: FETCH_SHIPPERINDIVIDUAL_FAIL_ACTION,
      error: err,
    });
  }
}

export function* AddOutboxRequestActionWatcher() {
  yield takeEvery(FETCH_REQUESTTYPE_ACTION, fetchrequesttype);
  yield takeEvery(FETCH_PARTNER_ACTION, fetchpartner);
  yield takeEvery(ADD_OUTBOX_ACTION, addoutbox);
  yield takeEvery(FETCH_SHIPPERINDIVIDUAL_ACTION, fetchshipperindidal);
}
